import * as React from 'react'
import { cn } from '@/models/app/lib/utils'

interface NavbarLogoProps {
  height?: string | number
  className?: string
}

export default function NavbarLogo({ height = '80px', className }: NavbarLogoProps) {
  const handleLogoError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement
    if (target.src.includes('/assets/logo')) {
      target.src = 'https://rolling-bones-rls-staging.herokuapp.com/assets/logo-6967183c50036b8d077c44499185a3e98342f0bcfc59df2ddb435c08e582a4db.png'
    }
  }

  return (
    <a href="/" className={cn('flex items-center flex-shrink-0', className)}>
      <img
        src="/assets/logo.png"
        alt="Rolling Bones Outfitters"
        className="w-auto"
        style={{ height: typeof height === 'number' ? `${height}px` : height }}
        onError={handleLogoError}
      />
    </a>
  )
}
